export default __webpack_public_path__ + "static/media/pheasant@2x.867ed8e9.jpg";